import React from 'react';
import {
  Box, IconButton, Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import RefreshIcon from '@mui/icons-material/Refresh';

import { Accordion, AccordionDetails, AccordionSummary } from '../SidebarAccordion.component';

import { ReactComponent as IntegrationIcon } from './integration.svg';
import { Tooltip, ProgressIcon } from '@uplift/ui-v2';
import { ICSSubscriptionDetails, calendarRefreshICSSubscription } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { useQueryClient } from '@tanstack/react-query';


export const SidebarICSIntegration: React.VFC<{ subscription: ICSSubscriptionDetails }> = ({ subscription }) => {
  const queryClient = useQueryClient();
  const [ refreshing, setRefreshing ] = React.useState(false);
  const updatedAtLabel = React.useMemo(() => {
    return CalendarDateService.date(subscription.updatedAt).fromNow();
  }, [ subscription.updatedAt ]);

  return (
    <Accordion elevation={0} defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography style={{ fontWeight: 600 }}>Google Calendar</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="flex" flexDirection="column" gap="16px" width="100%">
          <Box display="flex" width="100%">
            <Box style={{ width: 24 }}>
              <IntegrationIcon style={{ width: 24, height: 24 }} />
            </Box>
            <Box flex={1} overflow="hidden" textOverflow="ellipsis" pl={1}>
              <Typography
                style={{
                  lineHeight: '26px',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }}
                title={subscription.title}
              >
                {subscription.title}
              </Typography>
            </Box>
            <Box>
              <Tooltip
                title={refreshing ? (
                  <Typography variant="body2" color="inherit" align="center">
                    <span style={{ fontWeight: 450 }}>Refreshing...</span>
                  </Typography>
                ) : (
                  <Typography variant="body2" color="inherit" align="center">
                    <span style={{ fontWeight: 450 }}>Refresh calendar</span>
                    <br />
                    <span style={{ fontWeight: 400 }}>Last updated {updatedAtLabel}</span>
                  </Typography>
                )}
              >
                <IconButton
                  size="small"
                  onClick={async () => {
                    if (refreshing) return;

                    setRefreshing(true);
                    await calendarRefreshICSSubscription();
                    await queryClient.invalidateQueries([ 'icsSubscription' ]);
                    setRefreshing(false);
                  }}
                >
                  {refreshing
                    ? <Box width="20px" height="20px"><ProgressIcon /></Box>
                    : <RefreshIcon color="action" fontSize="small" />
                  }
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Typography variant="body2">External calendar events that affects your matching availability</Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
